import ReactModal from 'react-modal';

import cs from 'classnames';

import { cn } from 'lib/helpers/utility';

import ModalSidebar from './ModalSidebar/ModalSidebar';
import Footer from './components/Footer';
import Header from './components/Header';
import { MODAL_BODY_SPACE, MODAL_WIDTH } from './lib/index';

import './lib/Modal.scss';

/**
 * @param {import('./lib/propTypes').ModalProps}
 */

const Modal = ({
  isOpen = false,
  handleOpen = false, // use isOpen instead of handleOpen
  handleClose,
  title,
  children,
  width = 'small',
  isCentered = false,
  subModal,
  slideFromRight = true,
  isLarge = false,
  disableHeader = false,
  headButton,
  headerClassName,
  headerCloseIcon = true,
  customHeader,
  prevButton,
  footer,
  isFooter = true,
  footerActions,
  className,
  portalClassName,
  shouldCloseOnOverlayClick = true,
  overlayClassName,
  bodyClassName,
  footerClassName,
  customStyling,
  modalCenterAnimation = false,
  isSidebar = false,
  sidebarItems = [],
  onScroll,
  listClassName,
  contentClassName,
  ...rest
}) => {
  return (
    <ReactModal
      isOpen={isOpen || handleOpen}
      onRequestClose={handleClose}
      contentLabel={title}
      closeTimeoutMS={300}
      className={cn(
        'Modal',
        MODAL_WIDTH(width, isCentered),
        !slideFromRight && 'm-6 max-h-[calc(100vh-48px)] sm:m-4 sm:max-h-[calc(100vh-32px)]',
        isLarge && MODAL_WIDTH('full'),
        className
      )}
      overlayClassName={cs(
        'ModalOverlay',
        !isCentered && slideFromRight && 'ModalRightOverlay',
        modalCenterAnimation && 'ModalCenterAnimation',
        overlayClassName
      )}
      portalClassName={cs(portalClassName, subModal && 'SubModal')}
      ariaHideApp={false}
      shouldCloseOnOverlayClick={shouldCloseOnOverlayClick}
      style={{ content: customStyling }}
      {...rest}>
      {!disableHeader && (
        <Header
          title={title}
          headButton={headButton}
          headerClassName={headerClassName}
          headerCloseIcon={headerCloseIcon}
          customHeader={customHeader}
          prevButton={prevButton}
          handleClose={handleClose}
        />
      )}
      <div
        onScroll={onScroll}
        className={cn(
          'Modal__body',
          MODAL_BODY_SPACE(width, isCentered, isSidebar),
          bodyClassName
        )}>
        {isSidebar ? (
          <ModalSidebar
            items={sidebarItems}
            className={bodyClassName}
            listClassName={listClassName}
            contentClassName={contentClassName}
          />
        ) : (
          children
        )}
      </div>
      {footer ? (
        <div className={cs('Modal__footer h-[56px]', footerClassName)} data-dd-privacy="allow">
          {footer}
        </div>
      ) : (
        <Footer
          footerActions={footerActions}
          handleClose={handleClose}
          className={footerClassName}
          isFooter={isFooter}
        />
      )}
    </ReactModal>
  );
};
export default Modal;
